import { createI18n } from 'vue-i18n'
import { messages, type AppLocale } from './messages'

const savedLocale = localStorage.getItem('maple-log:locale')
const locale: AppLocale = savedLocale === 'en' ? 'en' : 'zh-CN'

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'zh-CN',
  messages,
})
